import { useQuery } from 'react-query'
import { message } from 'antd'
import { getApiRoles, getApiUsers } from 'utils/requests'
// helpers
import { useEffect } from 'react'

const useFetchData = (states, actions) => {
  const handlerRequest = useQuery<any>({
    queryKey: 'users-auth-roles',
    queryFn: () => getApiRoles(),
    initialData: [],
    select: rawData => {
      return rawData.map(({ role, ...rol }, i) => ({
        role,
        ...rol,
        key: `${role}-${i}`
      }))
    },
    onSuccess: () => {
      actions.setDirtyBit(false)
    },
    onError: () => {
      actions.setDirtyBit(false)
      message.error({
        type: 'error',
        content: 'Algo ha salido mal'
      })
    }
  })

  useEffect(() => {
    states.dirtyBit && handlerRequest.refetch()
  }, [states.dirtyBit])

  return handlerRequest
}

export default useFetchData
